<template>
  <BaseQEditor
    v-model="model"
    theme="snow"
    toolbar="essential"
    v-bind="$attrs"
  />
</template>

<script lang="ts" setup>
import BaseQEditor from './base/BaseQEditor.vue'

const model = defineModel<string>({
  required: true
})
</script>

